import React, { Component } from "react";
import language from "../../assets/languages/language";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import App_data from "../config/App_data";
import { renderHTMLContent } from "../../common/function";

/* eslint-disable*/
class PDFModelComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  pdfAlertModel(e) {
    e.preventDefault();
    this.props.pdfAlertModel(e);
  }

  render() {
    const { pdfAlert, PDFContentMessage, type } = this.props;
    return (
      <Modal
        isOpen={pdfAlert}
        toggle={this.pdfAlertModel.bind(this)}
        className={
          "modal-primary custom_modalpro info-modal-designing" +
          this.props.className
        }
      >
        <ModalHeader
          toggle={this.pdfAlertModel.bind(this)}
          className="custom-title"
        >
          <i className="fa fa-download" aria-hidden="true" /> {type}{" "}
          {language.LC().PDFDOWNLOAD}{" "}
        </ModalHeader>
        <ModalBody className="text-center payment-section-wrap">
          <div className="modal-info-view-for-plan ">
            <img
              src={App_data.frontend_url + "/img/" + "cloud-computing.png"}
              className="mb-2"
              width="90px"
              height="90px"
              alt=""
            />
            <div
              contentEditable="false"
            >
            {renderHTMLContent(PDFContentMessage, "div", "", { contentEditable: "false" })}
            </div>
            <br />
            <button
              type="button"
              className="btn btn-primary pointer_class"
              onClick={this.pdfAlertModel.bind(this)}
            >
              {language.LC().GO_TO_ANSWER}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default PDFModelComponent;



// WEBPACK FOOTER //
// ./src/views/Common/PDFModel.js